import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import i18next from "i18next";
import DataTable from "../../../components/dataTable/DataTable";
import _ from "lodash";
import styles from "./reportTable.module.scss";
import CustomPagination from "../../../components/pagination/CustomPagination";
import PropTypes from "prop-types";

const ReportTable = (props) => {
  const {
    pageSize = 1,
    pageNumber,
    totalRecords = 10,
    handlePageChange,
    handlePageSizeChange,
    onSortChange,
    sortModel = [],
    reportTable,
  } = props;
  const [tableColumnData, setTableColumnData] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const noDataFound = () => {
    return (
      <Box className={styles.folderIconWrapper}>
        <Box className={styles.folderIcon}></Box>
        <Box className={styles.textWrapper}>
          {i18next.t(
            "Select provider and date range to generate/view the report"
          )}
        </Box>
      </Box>
    );
  };
  useEffect(() => {
    const tableHeaderColumns = [
      {
        field: "exact_Number",
        headerName: i18next.t("Exact number"),
        minWidth: 120,
        sortable: false,
        renderCell: (params) => (
          <Box className={styles.headerText}>{params.row.exact_Number}</Box>
        ),
      },
      {
        field: "provider_Name",
        headerName: i18next.t("Providername"),
        minWidth: 110,
        sortable: false,
        renderCell: (params) => (
          <Box className={styles.headerText}>{params.row.provider_Name}</Box>
        ),
      },
      {
        field: "provider_Number",
        headerName: i18next.t("Providernumber"),
        minWidth: 130,
        sortable: false,
        renderCell: (params) => (
          <Box className={styles.headerText}>{params.row.provider_Number}</Box>
        ),
      },
      {
        field: "company_Name",
        headerName: i18next.t("Company name"),
        minWidth: 200,
        sortable: false,
        renderCell: (params) => (
          <Box className={styles.headerText}>{params.row.company_Name}</Box>
        ),
      },
      {
        field: "item_Code",
        headerName: i18next.t("Product code"),
        minWidth: 100,
        sortable: false,
        renderCell: (params) => (
          <Box className={styles.headerText}>{params.row.item_Code}</Box>
        ),
      },
      {
        field: "item_Description",
        headerName: i18next.t("Product description"),
        minWidth: 200,
        sortable: false,
        renderCell: (params) => (
          <Box className={styles.headerText}>{params.row.item_Description}</Box>
        ),
      },
      {
        field: "vehicleCount",
        headerName: i18next.t("Count"),
        minWidth: 100,
        sortable: !_.isEmpty(reportTable),
        renderCell: (params) => (
          <Box className={styles.headerText}>{params.row.vehicleCount}</Box>
        ),
      },
      {
        field: "unitPrice",
        headerName: `${i18next.t("Unit price")} (€)`,
        minWidth: 100,
        sortable: !_.isEmpty(reportTable),
        renderCell: (params) => (
          <Box className={styles.headerText}>{params.row.unitPrice}</Box>
        ),
      },
      {
        field: "total_Cost",
        headerName: `${i18next.t("Total cost")} (€)`,
        minWidth: 130,
        sortable: !_.isEmpty(reportTable),
        renderCell: (params) => (
          <Box className={styles.headerText}>{params.row.total_Cost}</Box>
        ),
      },
      {
        field: "transection_Date",
        headerName: i18next.t("Transaction date"),
        minWidth: 250,
        sortable: !_.isEmpty(reportTable),
        renderCell: (params) => (
          <Box className={styles.headerText}>{params.row.transection_Date}</Box>
        ),
      },
    ];
    setTableHeader(tableHeaderColumns);
    setTableColumnData(reportTable);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTable]);

  return (
    <Box data-testid="ReportTable">
      <Box className={styles.dataTableContainer}>
        <DataTable
          columns={tableHeader}
          rows={tableColumnData}
          rowHeight={tableColumnData?.length === 0 ? 200 : 64}
          isShowMessage={true}
          isShowTableWhenNoResult={tableColumnData?.length === 0}
          disableColumnMenu={true}
          disableColumnFilter={true}
          hideFooter={true}
          isCheckboxSelection={false}
          disableRowSelectionOnClick={true}
          // rowSelectionModel={[]}
          onSortModelChange={(model) => onSortChange(model)}
          sortModel={sortModel}
          noDataFound={() => noDataFound()}
        />
      </Box>
      {!_.isEmpty(tableColumnData) && pageSize < totalRecords ? (
        <CustomPagination
          row={tableColumnData}
          paginationResult={{
            pageSize: pageSize,
            pageNumber: pageNumber,
            totalRecords: totalRecords,
          }}
          setCurrentPageNumber={handlePageChange}
          showRowPerPage={false}
          setCurrentPageSize={handlePageSizeChange}
        />
      ) : null}
    </Box>
  );
};

export default ReportTable;
ReportTable.propTypes = {
  pageSize: PropTypes.any,
  pageNumber: PropTypes.any,
  totalRecords: PropTypes.any,
  handlePageChange: PropTypes.any,
  handlePageSizeChange: PropTypes.any,
  onSortChange: PropTypes.any,
  sortModel: PropTypes.any,
  reportTable: PropTypes.any,
};
